/* eslint-disable */
import React from 'react';
import { makeStyles, Theme, createStyles, Typography } from '@material-ui/core';
import Skeleton from '@material-ui/lab/Skeleton';

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      textAlign: 'left' as any,
      width: '100%' as any,
      fontWeight: 'bold' as any,
      fontSize: '14px',
      lineHeight: '17px',
      display: 'block',
      marginTop: '3px',
      color: theme.palette.common.black,
      opacity: 0.5
    }
  }));

export const ReportSubtitle: React.FC<{ loading?: boolean }> = (props) => {
  const classes = useStyles(props);
  const { children, loading } = props;

  if (loading) {
    return <Skeleton variant="rect" width={360} height={17} className={classes.root} />
  }

  return (
    <Typography className={classes.root} variant="h2" >
      {children}
    </Typography>
  );
}
